const state = {
  backendURL: "",
  mockBackendURL: "",
  appTitle: process.env.VUE_APP_TITLE,
  isNewLogIn: true,
  accessToken: "",
  buildMode: process.env.NODE_ENV,
  appVersion: "",
  oidcConfig: {},
  buildDestination: "",
};

const getters = {
  backendURL: (state) => state.backendURL,
  mockBackendURL: (state) => state.mockBackendURL,
  appTitle: (state) => state.appTitle,
  isNewLogIn: (state) => state.isNewLogIn,
  accessToken: (state) => state.accessToken,
  buildMode: (state) => state.buildMode,
  appVersion: (state) => state.appVersion,
  oidcConfig: (state) => state.oidcConfig,
  buildDestination: (state) => state.buildDestination,
};

const mutations = {
  cv(state, value) {
    state.isNewLogIn = value;
  },
  setAppVersion(state, value) {
    state.appVersion = value;
  },

  setBuildDestination(state, value) {
    state.buildDestination = value;
  },

  setAPI(state, value) {
    state.backendURL = value;
  },

  setMockAPI(state, value) {
    state.mockBackendURL = value;
  },

  setMapAccessToken(state, value) {
    state.accessToken = value;
  },

  setOidcConfig(state, value) {
    state.oidcConfig = value;
  },
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
